// introduced because of web components
export enum PopoverVerticalAlign {
  Center = 'Center',
  Top = 'Top',
  Bottom = 'Bottom',
  Stretch = 'Stretch'
}
